export default {
    state: {
        tasks: []
    },
    mutations: {
        updateTasks(state, tasks) {
            state.tasks = tasks
        },
        createTask(state, newTask) {
            state.tasks.unshift(newTask);
        },
        updateTask(state, upTask) {
            state.tasks.forEach((task, index) => {
                if ( task.id === upTask.id ) {
                    state.tasks.splice(index, 1 , upTask);
                }
            })
        },
    },
    actions: {
        async fetchTasks(ctx) {
            const res = await fetch('/test.json')
            const tasks = await res.json()

            ctx.commit('updateTasks', tasks)
        }
    },
    getters: {
        getTasks(state) {
            return state.tasks
        }
    }
}